import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Button, Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const BathSpaSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$local.$hpCopy' });

  return (
    <section className="base-section bath-spa-section main-hp hp-section">
      <div className="mod-wrap bg-left">
        <Link href={t('bathSpaLink')} className="module bath-body clearfix">
          <div className="outer-wrap">
            <div className="inner-wrap">
              <div className="title">
                <div className="inner-title">
                  <h2>{t('bathBodyHeading')}</h2>
                  <p>{t('bathBodyText')}</p>
                  <Button ariaLabel={t('bathSpaCta')}>{t('bathSpaCta')}</Button>
                </div>
              </div>
              <div className="exclusives-products">
                <span id="HP_bath_spa" className="exclusives-product-wrap">
                  <picture>
                    <img
                      src="/images/homepage/bathSpaSection/kem-towels-dsktp.webp"
                      alt="Bath & Spa"
                      width={630}
                      height={461}
                    />
                  </picture>
                </span>
              </div>
            </div>
          </div>
          <div className="branding-hero">
            <div className="img-wrap-tall">
              <picture>
                <source
                  srcSet="/images/homepage/bathSpaSection/kem-bisse-collection-mob.webp"
                  media="(max-width: 768px)"
                />
                <img
                  src="/images/homepage/bathSpaSection/kem-bisse-collection-dsktp.webp"
                  alt="Bath & Spa category"
                  width={1020}
                  height={977}
                />
              </picture>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default BathSpaSection;
